import { Navigate } from "react-router-dom";
import { AppInstallationGuideStepsSection } from "../components/AppInstallationGuideStepsSection";

const MOBILE_PUBLIC_SHELL_QUERY = "(max-width: 67.9375rem)";

function isMobilePublicShellViewport() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia(MOBILE_PUBLIC_SHELL_QUERY).matches
  );
}

export function AppInstallationGuideStepsPage() {
  if (isMobilePublicShellViewport()) {
    return (
      <Navigate
        replace
        to="/app-installation-guide#oac-installation-guide-steps"
      />
    );
  }

  return (
    <article className="oac-installation-steps-page">
      <header className="oac-installation-steps-page__header">
        <h1 className="oac-installation-steps-page__heading oac-membership-page__heading">
          App Installation Guide
        </h1>
      </header>

      <AppInstallationGuideStepsSection showBackLink />
    </article>
  );
}
